export default __webpack_public_path__ + "static/dSbGYXbE-1a7e7eeaa08bce204ad76e64efdd2a8f.svg";